(function($) {
    $(document).ready(function() {
	    $('.cta-box').matchHeight();
    });
})(jQuery);